/* Tuuli — Line Item Properties: translations + UX (robust locales, update-proof) */
(function () {
  'use strict';

  // ---- 1) Translation dictionary -----------------------------------------
  // Use base language keys AND common region variants.
  var T = {
    // BASE KEYS (catch both 'de' and 'de-DE', etc.)
    de: {
      label: 'Personalisierter Text',
      placeholder: 'Geben Sie hier Ihren personalisierten Text ein. Bei Schneidebrettern können Sie Text in mehreren Zeilen hinzufügen.'
    },
    fr: {
      label: 'Texte personnalisé',
      placeholder: 'Saisissez ici votre texte personnalisé. Pour les planches, vous pouvez ajouter du texte sur plusieurs lignes.'
    },
    it: {
      label: 'Testo personalizzato',
      placeholder: 'Inserisci qui il tuo testo personalizzato. Per i taglieri puoi aggiungere testo su più righe.'
    },
    es: {
      label: 'Texto personalizado',
      placeholder: 'Escribe aquí tu texto personalizado. En las tablas de cortar puedes añadir texto en varias líneas.'
    },
    nl: {
      label: 'Gepersonaliseerde tekst',
      placeholder: 'Typ hier je gepersonaliseerde tekst. Voor snijplanken kun je tekst over meerdere regels toevoegen.'
    },
    pt: {
      label: 'Texto personalizado',
      placeholder: 'Escreva aqui o seu texto personalizado. Nas tábuas de corte pode adicionar texto em várias linhas.'
    },
    sv: {
      label: 'Personlig text',
      placeholder: 'Skriv din personliga text här. För skärbrädor kan du lägga till text på flera rader.'
    },
    fi: {
      label: 'Personoitu teksti',
      placeholder: 'Kirjoita oma personoitu tekstisi tähän. Leikkuulaudoille voit lisätä tekstiä useille riveille.'
    },
    da: {
      label: 'Personlig tekst',
      placeholder: 'Skriv din personlige tekst her. Til skærebrætter kan du tilføje tekst over flere linjer.'
    },
    no: {
      label: 'Personlig tekst',
      placeholder: 'Skriv inn din personlige tekst her. På skjærebrett kan du legge til tekst i flere linjer.'
    },
    pl: {
      label: 'Tekst personalizowany',
      placeholder: 'Wpisz tutaj swój spersonalizowany tekst. Na deskach do krojenia możesz dodać tekst w kilku liniach.'
    },
    cs: {
      label: 'Personalizovaný text',
      placeholder: 'Sem zadejte svůj personalizovaný text. U prkének můžete přidat text na více řádků.'
    },
    sk: {
      label: 'Personalizovaný text',
      placeholder: 'Sem zadajte svoj personalizovaný text. Pri doskách môžete pridať text na viacerých riadkoch.'
    },
    hu: {
      label: 'Személyre szabott szöveg',
      placeholder: 'Ide írja be a személyre szabott szöveget. Vágódeszkára több soros szöveget is megadhat.'
    },
    ro: {
      label: 'Text personalizat',
      placeholder: 'Introduceți aici textul personalizat. Pentru tocătoare puteți adăuga text pe mai multe rânduri.'
    },
    el: {
      label: 'Προσωποποιημένο κείμενο',
      placeholder: 'Πληκτρολογήστε εδώ το προσωπικό σας κείμενο. Για ξύλα κοπής μπορείτε να προσθέσετε κείμενο σε πολλές γραμμές.'
    },
    tr: {
      label: 'Kişiselleştirilmiş metin',
      placeholder: 'Kişiselleştirilmiş metninizi buraya yazın. Kesme tahtalarında birden fazla satır ekleyebilirsiniz.'
    },
    uk: {
      label: 'Персоналізований текст',
      placeholder: 'Введіть тут свій персоналізований текст. Для обробних дощок можна додати текст у кілька рядків.'
    },
    ja: {
      label: '名入れテキスト',
      placeholder: 'こちらに名入れテキストをご入力ください。まな板では複数行のテキストも追加できます。'
    },
    ar: {
      label: 'نص مخصص',
      placeholder: 'اكتب نصك المخصص هنا. في ألواح التقطيع يمكنك إضافة نص في عدة أسطر.'
    },

    // EN is the global fallback
    en: {
      label: 'Personalized text',
      placeholder: 'Type your personalized text here…'
    },

    // REGION OVERRIDES where wording differs (optional)
    'pt-br': {
      label: 'Texto personalizado',
      placeholder: 'Digite aqui seu texto personalizado. Em tábuas de corte você pode adicionar texto em várias linhas.'
    },
    'es-mx': {
      label: 'Texto personalizado',
      placeholder: 'Escribe aquí tu texto personalizado. En tablas para cortar puedes añadir texto en várias linhas.'
    },
    'fr-be': {
      label: 'Texte personnalisé',
      placeholder: 'Saisissez ici votre texte personnalisé. Pour les planches, vous pouvez ajouter du texte sur plusieurs lignes.'
    },
    'de-at': {
      label: 'Personalisierter Text',
      placeholder: 'Geben Sie hier Ihren personalisierten Text ein. Bei Schneidebrettern können Sie Text in mehreren Zeilen hinzufügen.'
    },
    'de-ch': {
      label: 'Personalisierter Text',
      placeholder: 'Geben Sie hier Ihren personalisierten Text ein. Bei Schneidebrettern können Sie Text in mehreren Zeilen hinzufügen.'
    }
  };

  var FIELD_SELECTOR = [
    '.line-item-properties input[type="text"]',
    '.line-item-properties textarea',
    '.line-item-property input[type="text"]',
    '.line-item-property textarea'
  ].join(', ');

  var WRAP_SELECTOR =
    '.line-item-properties .property, .line-item-property .form-control';

  var uxListenersBound = false;

  // ---- 2) Locale normalization --------------------------------------------
  function normalizeLocale(lang) {
    if (!lang) return 'en';

    var normalized = String(lang)
      .toLowerCase()
      .replace(/_/g, '-');

    var alias = {
      'tr-tu': 'tr-tr',
      'uk-uk': 'uk-ua',
      'ar-ar': 'ar-sa'
    };

    return alias[normalized] || normalized;
  }

  function chooseStrings(lang) {
    var locale = normalizeLocale(lang);

    if (T[locale]) {
      return T[locale];
    }

    var base = locale.split('-')[0];

    return T[base] || T.en;
  }

  function forEachMatch(scope, selector, callback) {
    var root =
      scope && scope.querySelectorAll
        ? scope
        : document;

    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches(selector)
    ) {
      callback(root);
    }

    root.querySelectorAll(selector).forEach(callback);
  }

  // ---- 3) Apply translations + UX -----------------------------------------
  function applyTranslations(scope) {
    var strings = chooseStrings(
      document.documentElement.getAttribute('lang') || ''
    );

    forEachMatch(scope, WRAP_SELECTOR, function (wrap) {
      var label = wrap.querySelector('label, .floating-label');
      var input = wrap.querySelector(
        'input[type="text"], textarea'
      );

      if (!input) {
        return;
      }

      if (label) {
        label.textContent = strings.label;
      }

      input.setAttribute(
        'name',
        'properties[' + strings.label + ']'
      );

      input.setAttribute(
        'placeholder',
        strings.placeholder
      );
    });
  }

  function toggleState(input) {
    var wrap = input.closest(WRAP_SELECTOR);

    if (!wrap) {
      return;
    }

    wrap.classList.toggle(
      'has-value',
      String(input.value || '').trim().length > 0
    );
  }

  function applyInitialUXState(scope) {
    forEachMatch(
      scope,
      FIELD_SELECTOR,
      toggleState
    );
  }

  function handleFieldUpdate(event) {
    var target = event.target;

    if (
      target &&
      target.matches &&
      target.matches(FIELD_SELECTOR)
    ) {
      toggleState(target);
    }
  }

  function bindUXListenersOnce() {
    if (uxListenersBound) {
      return;
    }

    uxListenersBound = true;

    document.addEventListener(
      'input',
      handleFieldUpdate
    );

    document.addEventListener(
      'change',
      handleFieldUpdate
    );
  }

  function init(scope) {
    var root =
      scope && scope.querySelectorAll
        ? scope
        : document;

    applyTranslations(root);
    applyInitialUXState(root);
    bindUXListenersOnce();
  }

  function handleShopifySectionEvent(event) {
    init(event.target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener(
    'shopify:section:load',
    handleShopifySectionEvent
  );

  document.addEventListener(
    'shopify:section:select',
    handleShopifySectionEvent
  );
})();

/* Tuuli — Strip Shopify recommendations tracking params (?pr_*) from product links */
(function () {
  'use strict';

  var PR_LINK_SELECTOR = 'a[href*="pr_" i]';
  var pendingRoots = new Set();
  var scanScheduled = false;

  function isInternalProductUrl(url) {
    return Boolean(
      url &&
      url.origin === window.location.origin &&
      url.pathname.indexOf('/products/') !== -1
    );
  }

  function hasPrParams(url) {
    var keys = url.searchParams.keys();
    var next = keys.next();

    while (!next.done) {
      if (
        String(next.value)
          .toLowerCase()
          .indexOf('pr_') === 0
      ) {
        return true;
      }

      next = keys.next();
    }

    return false;
  }

  function stripPrParams(url) {
    var changed = false;
    var keys = Array.from(
      url.searchParams.keys()
    );

    keys.forEach(function (key) {
      if (
        String(key)
          .toLowerCase()
          .indexOf('pr_') === 0
      ) {
        url.searchParams.delete(key);
        changed = true;
      }
    });

    if (!changed) {
      return null;
    }

    var query = url.searchParams.toString();

    return (
      url.pathname +
      (query ? '?' + query : '') +
      (url.hash || '')
    );
  }

  function cleanAnchor(anchor) {
    if (!anchor || !anchor.getAttribute) {
      return false;
    }

    var raw = anchor.getAttribute('href');

    if (
      !raw ||
      raw.toLowerCase().indexOf('pr_') === -1
    ) {
      return false;
    }

    // Ignore anchors and special protocols.
    var lower = raw.toLowerCase();

    if (
      lower.indexOf('#') === 0 ||
      lower.indexOf('mailto:') === 0 ||
      lower.indexOf('tel:') === 0 ||
      lower.indexOf('javascript:') === 0
    ) {
      return false;
    }

    var url;

    try {
      url = new URL(
        raw,
        window.location.origin
      );
    } catch (error) {
      return false;
    }

    if (
      !isInternalProductUrl(url) ||
      !hasPrParams(url)
    ) {
      return false;
    }

    var cleaned = stripPrParams(url);

    if (!cleaned) {
      return false;
    }

    // Keep href relative for clean copy/link display.
    anchor.setAttribute(
      'href',
      cleaned
    );

    return true;
  }

  function scanRoot(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches(PR_LINK_SELECTOR)
    ) {
      cleanAnchor(root);
    }

    root
      .querySelectorAll(PR_LINK_SELECTOR)
      .forEach(cleanAnchor);
  }

  function cleanCurrentUrlBar() {
    if (
      window.location.pathname.indexOf(
        '/products/'
      ) === -1
    ) {
      return;
    }

    if (
      !window.location.search ||
      window.location.search
        .toLowerCase()
        .indexOf('pr_') === -1
    ) {
      return;
    }

    var url = new URL(
      window.location.href
    );

    if (!hasPrParams(url)) {
      return;
    }

    var cleaned = stripPrParams(url);

    if (!cleaned) {
      return;
    }

    // No reload. Preserve the current history state.
    window.history.replaceState(
      window.history.state,
      '',
      cleaned
    );
  }

  function flushPendingRoots() {
    scanScheduled = false;

    pendingRoots.forEach(function (root) {
      scanRoot(root);
    });

    pendingRoots.clear();
  }

  function scheduleRootScan(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    var coveredByExistingRoot = false;
    var rootsToDelete = [];

    pendingRoots.forEach(function (existingRoot) {
      if (
        existingRoot === root ||
        (
          existingRoot.contains &&
          existingRoot.contains(root)
        )
      ) {
        coveredByExistingRoot = true;
      } else if (
        root.contains &&
        root.contains(existingRoot)
      ) {
        rootsToDelete.push(existingRoot);
      }
    });

    if (coveredByExistingRoot) {
      return;
    }

    rootsToDelete.forEach(function (existingRoot) {
      pendingRoots.delete(existingRoot);
    });

    pendingRoots.add(root);

    if (scanScheduled) {
      return;
    }

    scanScheduled = true;

    window.requestAnimationFrame(
      flushPendingRoots
    );
  }

  function startObserver() {
    var observerRoot =
      document.body ||
      document.documentElement;

    if (!observerRoot) {
      return;
    }

    var observer = new MutationObserver(
      function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(
            function (node) {
              if (
                node.nodeType === 1 ||
                node.nodeType === 11
              ) {
                scheduleRootScan(node);
              }
            }
          );
        });
      }
    );

    observer.observe(observerRoot, {
      childList: true,
      subtree: true
    });
  }

  cleanCurrentUrlBar();

  // Clean the initial document once, then observe only newly inserted DOM roots.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scanRoot(document);
        startObserver();
      },
      { once: true }
    );
  } else {
    scanRoot(document);
    startObserver();
  }

  // Click-time fallback for links changed immediately before navigation.
  document.addEventListener(
    'click',
    function (event) {
      var anchor =
        event.target &&
        event.target.closest
          ? event.target.closest('a')
          : null;

      if (anchor) {
        cleanAnchor(anchor);
      }
    },
    true
  );
})();